import { cn } from "@/lib/utils";

const RAG = {
  green: { label: "On Track", bg: "#DFF6DD", text: "#107C41", border: "#107C41" },
  amber: { label: "At Risk", bg: "#FFF4CE", text: "#8A6D00", border: "#B3B000" },
  red: { label: "Behind", bg: "#FDE7E9", text: "#A80000", border: "#A80000" },
  not_rated: { label: "Not Rated", bg: "#F3F2F1", text: "#605E5C", border: "#8A8886" },
};

export const RAG_HEX = { green: "#107C41", amber: "#D97706", red: "#A80000", not_rated: "#8A8886" };

export const RagChip = ({
  rag, className, testid,
  isOverridden, overrideBy, overrideAt, preRag, overrideReason,
  catchupAmber, catchupGreen,
}) => {
  const cfg = RAG[rag] || RAG.not_rated;

  let title;
  if (isOverridden) {
    const orig = RAG[preRag]?.label || preRag || "—";
    const when = overrideAt ? String(overrideAt).slice(0, 10) : "";
    title = `Manually set to ${cfg.label} by ${overrideBy || "admin"}${when ? ` on ${when}` : ""}: ${overrideReason || ""}. Original: ${orig}.`;
  } else if (rag === "red" && (catchupAmber != null || catchupGreen != null)) {
    title = `Needs ≥${catchupAmber ?? "—"}% completion to reach Amber, ≥${catchupGreen ?? "—"}% for Green`;
  }

  return (
    <span className="inline-flex items-center gap-1.5">
      <span
        data-testid={testid}
        title={title}
        className={cn(
          "inline-flex items-center gap-1.5 rounded-full px-2.5 py-0.5 text-xs font-semibold border",
          className
        )}
        style={{ backgroundColor: cfg.bg, color: cfg.text, borderColor: cfg.border }}
      >
        <span className="h-2 w-2 rounded-full" style={{ backgroundColor: cfg.border }} />
        {cfg.label}
      </span>
      {isOverridden && (
        <span
          data-testid={testid ? `${testid}-overridden` : "overridden-badge"}
          title={title}
          className="inline-flex items-center rounded-full px-2 py-0.5 text-[10px] font-semibold border"
          style={{ backgroundColor: "#EEF2FF", color: "#4338CA", borderColor: "#6366F1" }}
        >
          Overridden
        </span>
      )}
    </span>
  );
};
